module.exports = __webpack_public_path__ + "img/Mixed Cells.8e1217e3.png";